import React, { FunctionComponent, useState, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';
import type { PersonShowMainProps as Props, PersonShowMainState } from './types';
import { fetchUserDetails } from '../../../services/people';
import { fetchIsScouted } from '../../../services/scouts';
import { fetchLiked1monthAgo } from '../../../services/notifications';
import { useModal } from '../../../hooks/useModal';

export const Component: FunctionComponent<Props> = (props) => {
  const [state, setState] = useState<PersonShowMainState>({
    personSrc: '',
    isModalOpen: false,
    loading: false,
    loadingStyle: {},
    modalStyle: {},
    targetButton: '',
    fadeIn: false,
    fadeOut: false,
    blur: true,
    isBookmarked: false,
    liked1monthAgo: false,
    recentlyActiveDate: '',
    recentlySignedIn: '',
    recentlyUpdated: '',
    scouted: false,
    icon: '',
    body: '',
  });
  const { isOpen: isRecommendModalOpen, open: handleRecommendModalOpen, close: handleRecommendModalClose } = useModal(false, {
    lockBody: true
  });
  const { isOpen: isRecommendMinimumModalOpen, open: handleRecommendMinimumModalOpen, close: handleRecommendMinimumModalClose } = useModal(false, {
    lockBody: true
  });

  useEffect(() => {
    props.handleFetchDetails();
    if (props.fromPage === 'scout') {
      personIsScouted();
      handleFetchLiked1monthAgo();
    }
    if (props.fromPage === 'companyShow') {
      handleFetchUserDetails();
    }
  }, []);

  const handleFetchUserDetails = async () => {
    try {
      const response = await fetchUserDetails(props.personId);
      setState(prev => ({
        ...prev,
        recentlyActiveDate: response.recentlyActiveDate,
        recentlySignedIn: response.recentlySignedIn,
        recentlyUpdated: response.recentlyUpdated,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const personIsScouted = async () => {
    try {
      const response = await fetchIsScouted(props.personId)
      setState(prev => ({
        ...prev,
        scouted: response.scouted,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleFetchLiked1monthAgo = async () => {
    try {
      const response = await fetchLiked1monthAgo(props.personId)
      setState(prev => ({
        ...prev,
        liked1monthAgo: response.liked1monthAgo,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleLike = () => {
    setState(prev => ({ ...prev, liked1monthAgo: true }));
    props.handleLike();
  };

  const handleModalOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    const targetButton = e.currentTarget.nextElementSibling as HTMLElement || '';
    if (props.isMinimum) {
      handleRecommendMinimumModalOpen();
      return;
    }
    if (!props.isAllowedToSendScout) {
      handleRecommendModalOpen();
      return;
    }
    const icon = document.querySelector<HTMLElement>('.person__show__sidebar__heading--icon--img')?.getAttribute('src') || '';
    setState(prev => ({
      ...prev,
      isModalOpen: true,
      modalStyle: { display: 'block', zIndex: '1100' },
      personId: props.personId,
      personSrc: icon,
      targetButton: targetButton,
    }));
  };

  const handleModalOff = () => {
    setState(prev => ({ ...prev, recommend: false, recommendMinimum: false, modalStyle: { display: 'none' } }));
  };

  const handleModalClose = () => {
    setState(prev => ({ ...prev, isModalOpen: false, loadingStyle: { display: 'none' } }));
  };

  const insertNotification = () => {
    props.insertFlashScout();
  };

  const handleOpenModal = useCallback((target: string, title: string) => {
    props.handleOpenModal(target, title);
  }, [props.handleOpenModal]);

  const onChangeClickTarget = useCallback((value: number) => {
    props.onChangeClickTarget(value);
  }, [props.onChangeClickTarget]);

  const handleFetchSidebarDetails = () => {
    props.handleFetchSidebarDetails();
  };

  const handleRequestResume = (type: string) => {
    props.handleRequestResume(type);
  };

  return (
    <Presentation
      state={state}
      isRecommendModalOpen={isRecommendModalOpen}
      isRecommendMinimumModalOpen={isRecommendMinimumModalOpen}
      onClickLike={handleLike}
      handleModalOpen={handleModalOpen}
      handleModalOff={handleModalOff}
      handleModalClose={handleModalClose}
      handleRecommendModalClose={handleRecommendModalClose}
      handleRecommendMinimumModalClose={handleRecommendMinimumModalClose}
      insertNotification={insertNotification}
      onOpenModal={handleOpenModal}
      handleChangeClickTarget={onChangeClickTarget}
      fetchSidebarDetails={handleFetchSidebarDetails}
      sensRequestResume={handleRequestResume}
      personIsScouted={personIsScouted}
      {...props}
    />
  );
};
